import { render, staticRenderFns } from "./shipSummary.vue?vue&type=template&id=4893d5d6&scoped=true&"
import script from "./shipSummary.vue?vue&type=script&lang=js&"
export * from "./shipSummary.vue?vue&type=script&lang=js&"
import style0 from "./shipSummary.vue?vue&type=style&index=0&id=4893d5d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4893d5d6",
  null
  
)

export default component.exports